import { Stack, StackProps, Text } from '@chakra-ui/react';

/**
 * Трейдмарк-дисклеймер по играм для футеров (лендинги + приложение).
 *
 * Юридический boilerplate — намеренно без Lingui (такой текст принято не переводить).
 * Универсальный абзац покрывает всех издателей разом (Valve, EA, Activision…), именные —
 * тех, чьи материалы у нас представлены заметнее прочих: Riot (условия их API, которым мы
 * пользуемся), Epic (Fan Content Policy, арт Fortnite на лендинге) и Ubisoft — у нас две их
 * игры, The Division 2 и Rainbow Six Siege, причём у второй на сайте лежит больше сотни
 * внутриигровых иконок. Формулировка трейдмарков взята с их же витрины дословно.
 * Blizzard — две игры, Overwatch и World of Warcraft; их Trademark Guidelines требуют строку
 * о принадлежности знака, её формулировка взята оттуда же. Moonton — Mobile Legends: Bang Bang,
 * у которой на сайте лежат ключевой арт, двенадцать фонов заявки и весь список героев.
 */
const PARAGRAPHS = [
  'Delta Force and its artwork are trademarks and/or copyrighted works of their respective ' +
    'owners. This material is not official and is not endorsed by Team Jade or Level Infinite.',
  'Teamplay.gg is not affiliated with, endorsed, sponsored, or approved by any game ' +
    'publisher. All game titles, artwork, and associated imagery are trademarks and/or ' +
    'copyright material of their respective owners.',
  "Teamplay.gg isn't endorsed by Riot Games and doesn't reflect the views or opinions of " +
    'Riot Games or anyone officially involved in producing or managing Riot Games ' +
    'properties. Riot Games and all associated properties are trademarks or registered ' +
    'trademarks of Riot Games, Inc.',
  'Portions of the materials used are trademarks and/or copyrighted works of Epic Games, ' +
    'Inc. This material is not official and is not endorsed by Epic.',
  "Tom Clancy's, The Division logo, Rainbow Six, the Soldier Icon, Ubisoft, and the Ubisoft " +
    'logo are registered or unregistered trademarks of Ubisoft Entertainment in the US ' +
    'and/or other countries. This material is not official and is not endorsed by Ubisoft.',
  'Overwatch, World of Warcraft, Warcraft and Blizzard Entertainment are trademarks or ' +
    'registered trademarks of Blizzard Entertainment, Inc., in the U.S. and/or other ' +
    'countries. Teamplay.gg is not affiliated with or endorsed by Blizzard Entertainment.',
  'Mobile Legends: Bang Bang and MLBB are trademarks or registered trademarks of Shanghai ' +
    'Moonton Technology Co., Ltd. This material is not official and is not endorsed by Moonton.',
];

export const GameTrademarksNotice = (props: StackProps) => (
  <Stack gap={1.5} {...props}>
    {PARAGRAPHS.map((paragraph) => (
      <Text key={paragraph.slice(0, 24)} textStyle="caption" color="fg.muted" lineHeight="tall">
        {paragraph}
      </Text>
    ))}
  </Stack>
);
